import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const painPoints = [{
    emoji: '😔',
    text: 'Sientes que la vida está estancada'
  }, {
    emoji: '💪',
    text: 'Sientes que podrías dar más pero no sabes cómo'
  }, {
    emoji: '💡',
    text: 'Tienes muchas ideas pero poca claridad'
  }, {
    emoji: '💰',
    text: 'Sientes que necesitas ganar más pero no sabes cómo'
  }, {
    emoji: '🧭',
    text: 'Te falta disciplina y dirección'
  }, {
    emoji: '⏰',
    text: 'No tienes tiempo para generar un ingreso B, pero lo necesitas'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-177">
          <span className="inline-block px-4 py-1.5 rounded-full bg-pink-500/20 text-pink-300 border border-pink-500/30 font-semibold text-sm tracking-wide uppercase mb-6" data-id="element-178">
            ⭐ Destacado
          </span>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white leading-tight" data-id="element-179">
            Este sistema es para ti...
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-180">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-start gap-4 p-5 rounded-2xl bg-white/[0.05] border border-white/10 hover:border-pink-500/30 transition-colors" data-id="element-181">
              <span className="text-3xl flex-shrink-0 mt-0.5" data-id="element-182">
                {point.emoji}
              </span>
              <span className="text-slate-200 text-lg font-medium leading-snug" data-id="element-183">
                {point.text}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mt-12 p-6 bg-pink-500/10 rounded-2xl border border-pink-500/20" data-id="element-184">
          <p className="text-xl font-semibold text-pink-100 text-center" data-id="element-185">
            Si te identificas con al menos uno de estos puntos,{' '}
            <span className="text-pink-400" data-id="element-186">este kit fue creado para ti.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}